import { Injectable, OnInit } from '@angular/core';
import { LucideIconService } from './lucide-icon.service';

@Injectable({
  providedIn: 'root'
})
export class IconPreloaderService implements OnInit {

  constructor(private lucideIconService: LucideIconService) {}

  ngOnInit(): void {
    this.preloadCommonIcons();
  }

  /**
   * Pre-carga iconos comunes al iniciar la aplicación
   */
  async preloadCommonIcons(): Promise<void> {
    try {
      await this.lucideIconService.preloadCommonIcons();
    } catch (error) {
      console.warn('Error pre-cargando iconos comunes:', error);
    }
  }

  /**
   * Pre-carga iconos específicos
   */
  async preloadIcons(iconNames: string[]): Promise<void> {
    const loadPromises = iconNames.map(iconName =>
      this.lucideIconService.loadIcon(iconName)
    );

    try {
      await Promise.allSettled(loadPromises);
    } catch (error) {
      console.warn('Error pre-cargando iconos específicos:', error);
    }
  }
}

